<template>
  <div class="nome-sito" style="font-size: 48px; color: #198754;font-weight:700">
    <span style="font-size: 48px;margin-right: 3px">F</span>
    <span style="font-size: 48px;margin-right: 3px">a</span>
    <span style="font-size: 48px;margin-right: 3px">c</span>
    <span style="font-size: 48px;margin-right: 3px">i</span>
    <span style="font-size: 48px;margin-right: 3px">l</span>
    <span style="font-size: 48px;margin-right: 3px">e</span>
    <span style="font-size: 48px;margin-right: 12px"></span>
    <span style="font-size: 48px;margin-right: 3px">C</span>
    <span style="font-size: 48px;margin-right: 3px">h</span>
    <span style="font-size: 48px;margin-right: 3px">e</span>
    <span style="font-size: 48px;margin-right: 3px">c</span>
    <span style="font-size: 48px;margin-right: 3px">k</span>
    <span style="font-size: 32px;margin-left: -3px;margin-right:3px">-</span>
    <span style="font-size: 48px;margin-left: -3px;margin-right:3px">i</span>
    <span style="font-size: 48px;margin-right: 3px">n</span>
  </div>
</template>

<script>
export default {
  name: "NomeSito",
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nome-sito {
  font-family: "Poiret One", cursive;
  font-size: 48px;
  color: #337ab7;
}
</style>
